module.exports = __webpack_public_path__ + "static/media/paraflux_games-preview.1c4e53f1.png";